import React from 'react'

import { SxProps, Theme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Container, { ContainerProps } from '@mui/material/Container'
import { useIsMobile } from '@/hooks/useSizeBreakpoints'

export type PageContainerProps = {
  children?: React.ReactNode
  maxWidth?: ContainerProps['maxWidth']
  sx?: SxProps<Theme>
  noPadding?: boolean
}

export function PageContainer(props: PageContainerProps) {
  const { children, maxWidth = 'xl', sx = [], noPadding = false } = props
  const isMobile = useIsMobile()

  const p = noPadding ? '0' : (isMobile ? '10px' : '30px')
  return (
    <Container maxWidth={maxWidth} sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <Box sx={{ p: p, height: '100%' }}>{children}</Box>
    </Container>
  )
}

export default PageContainer
